'use client';

import { ReactLenis } from 'lenis/react';
import type { ReactNode } from 'react';

import { usePrefersReducedMotion } from './usePrefersReducedMotion';

export function LenisProvider({ children }: { children: ReactNode }) {
	const reducedMotion = usePrefersReducedMotion();

	if (reducedMotion) return <>{children}</>;

	return (
		<ReactLenis
			root
			options={{
				// When lerp is set, Lenis ignores `duration`/`easing`. Keep just lerp.
				lerp: 0.08,
				smoothWheel: true,
				syncTouch: false,
			}}
		>
			{children}
		</ReactLenis>
	);
}
